import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Algorithmic Programmer',
    title: "Technology Consultant",
    desciption: "I'm a technology enthusiast and consultant based in the United States. I am well-versed in several aspects of software development including but not limited to design, full-stack development, testing, and deployment.",
    image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    resumePdf: resume
}
